<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">

        <el-form-item
          v-if="$store.state.roleId == '1070960390067716097'"
          label="代理"
          >
          <el-select 
            v-model="form.agentId" 
            placeholder="请选择代理"
            :popper-append-to-body="false"
            popper-class="eloption"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in agentList"
              :key="item.agentId"
              :label="item.agentId + '-' + item.agentName"
              :value="item.agentId"
            ></el-option>
          </el-select>
        </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button
            :loading="loading"
            type="primary"
            @click="exportDetail"
            size="small"
          >
          导出报表</el-button
          >
        </template>


        <template slot="tableColumn">

          <el-table-column
            width="120"
            prop="statisticsDate"
            label="日期"
            :formatter="$formatter.formatDate"
            align="center"
          ></el-table-column>

          <el-table-column
            width="200"
            prop="updateTime"
            label="刷新时间"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="paymentAmount"
            :formatter="$formatter.FenToYuan"
            label="代收金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="paymentFee"
            :formatter="$formatter.FenToYuan"
            label="代收手续费"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="paymentAgentFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="代理利润"
            align="center"
          ></el-table-column>
          <el-table-column
            width="90px"
            prop="paymentCountSuccess"
            label="代收成功数"
            align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="140px"
            prop="transferAmount"
            :formatter="$formatter.FenToYuan"
            label="代付金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="transferFee"
            :formatter="$formatter.FenToYuan"
            label="代付手续费"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="transferAgentFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="代理利润"
            align="center"
          ></el-table-column>
          <el-table-column
            width="90px"
            prop="transferCountSuccess"
            label="代付成功数"
            align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="140px"
            prop="depositAmount"
            :formatter="$formatter.FenToYuan"
            label="充值金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="withdrawAmount"
            :formatter="$formatter.FenToYuan"
            label="提现金额"
            align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="180px"
            prop="merAvailableBalance"
            :formatter="$formatter.FenToYuan"
            label="商户可用余额"
            align="center"
          ></el-table-column>
          
          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="140px"
            prop="channelBalance"
            :formatter="$formatter.FenToYuan"
            label="银行结余"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="merBalance"
            :formatter="$formatter.FenToYuan"
            label="商户结余"
            align="center"
          ></el-table-column>

          <el-table-column
            width="140px"
            prop="platformBalance"
            :formatter="$formatter.FenToYuan"
            label="平台结余"
            align="center"
          ></el-table-column>

        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/statistics-platform/listStatisticsPlatform",
      merchantList: [],
      agentList: [],
      form: {
        appId: "",
        startDate: "",
        endDate: "",
        tradeOrderId: "",
      },
      timeDate: [],
      loading:false
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD');; 
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },

    exportDetail() {
      this.loading = true
      this.axios
        .get('/statistics-platform/listStatisticsPlatformExport', {
          params: this.form,
        })
        .then(res => {
          if (res.code != 200) {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }
        })
      this.loading = false
    },

  },

  created() {
    let start = moment().subtract(7, 'days').format('yyyyMMDD');; 
    let end = moment().format('yyyyMMDD');
    this.form.startDate = start;
    this.form.endDate = end;
    this.timeDate = [start, end];

    if (this.$store.state.roleId == '1070960390067716097') {
      this.$axios.get('/agent/selectAgentForOption', { params: {} })
        .then(res => {
          this.agentList = res.data
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.el-form-item {
  margin-bottom: 5px;
}
</style>